/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Empty_BodyInputs */

const en_product_empty_body = /** @type {(inputs: Product_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture the first bug, idea or task. It takes a few seconds.`)
};

const de_product_empty_body = /** @type {(inputs: Product_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasse den ersten Fehler, die erste Idee oder Aufgabe. Das dauert nur Sekunden.`)
};

/**
* | output |
* | --- |
* | "Capture the first bug, idea or task. It takes a few seconds." |
*
* @param {Product_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const product_empty_body = /** @type {((inputs?: Product_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_product_empty_body(inputs)
	return en_product_empty_body(inputs)
});